// LanguageContext.js
import React, { createContext, useState, useEffect } from 'react';

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const getInitialLanguage = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const langFromURL = urlParams.get('lang');

    if (langFromURL === 'ar' || langFromURL === 'en') {
      return langFromURL;
    }

    const langFromStorage = localStorage.getItem('language');
    return langFromStorage === 'en' || langFromStorage === 'ar' ? langFromStorage : 'en';
  };

  const [language, setLanguage] = useState(getInitialLanguage);

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('language', lang);
  };

  // useEffect(() => {
  //   document.body.dir = language === 'ar' ? 'rtl' : 'ltr';
  //   document.body.classList.toggle('rtl', language === 'ar');
  //   document.body.classList.toggle('ltr', language === 'en');
  // }, [language]);

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
